export default "__VITE_ASSET__BPNa378g__"